// src/components/Footer.tsx
import SocialLinks from "./SocialLinks";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="py-12 px-4 bg-secondary/50">
      <div className="container mx-auto max-w-5xl">
        <div className="flex flex-col items-center">
          <h2 className="text-2xl font-display font-medium mb-4">Priya Pareek</h2>
          <p className="text-muted-foreground mb-6 text-center max-w-md">
            Creating meaningful visual experiences through art and design
          </p>
          <SocialLinks className="mb-8" />
          <div className="h-px w-full max-w-sm bg-border mb-6" />
          <div className="text-center text-sm text-muted-foreground space-y-2">
            <p>
              Designed & Built by{" "}
              <a
                href="https://digitalpro.dev"
                target="_blank"
                rel="noreferrer"
                className="hover:text-primary hover:underline transition-colors duration-300"
              >
                DigitalPro
              </a>
            </p>
            <p>© {currentYear} Priya Pareek. All rights reserved.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;